import React,{useEffect, useState} from 'react'
import { useCurrent,useFetch } from '../../../hooks';
import CardHeadeWithActions from '../../../components/ui/CardHeadeWithActions';
import { MwButton, MwSpinner, NoDataFound } from '../../../components/ui';
import StockTakingListItem from './StockTakingListItem';
import { useTranslation } from 'react-i18next';
import { BiSearch } from 'react-icons/bi';

const StockTakingList = ({added}) => {
    const {currentTenantId,currentCompanyId,currentBranchId} = useCurrent();
    const {data:stockTakingResult,loading:stockTakingWarehouse,refreshHandler} = useFetch(`${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/stocktaking/master/${currentTenantId}/${currentCompanyId}/${currentBranchId}`)
    const [searchQuery, setSearchQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    useEffect(() => {
        if(stockTakingResult){
            console.log('stockTakingResult',stockTakingResult)
        }
    },[stockTakingResult]);

    useEffect(() =>{
        if(added){

            refreshHandler();
            console.log('added',added);
        }
    },[added]);

    useEffect(() => {
      if (stockTakingResult?.data && searchQuery) {
        const filtered = stockTakingResult.data
          .filter(item => {
            const normalizedCode = item.code?.toLowerCase().trim() || '';
            const normalizedSearch = searchQuery.toLowerCase().trim();
            return normalizedCode.includes(normalizedSearch) || 
                   normalizedCode.replace('stk', '').includes(normalizedSearch) ||
                   normalizedCode.replace('-', '').includes(normalizedSearch);
          })
          .map(item => item.code);
        setSuggestions(filtered);
      } else {
        setSuggestions([]);
      }
    }, [searchQuery, stockTakingResult]);

    const [t,i18n ] = useTranslation('global')
    const isRTL = i18n.dir() === 'rtl';
    if(stockTakingWarehouse) {
        return <MwSpinner />
      }

      const filteredResults = stockTakingResult?.data?.filter((item) => {
        if (!searchQuery) return true;
        
         const normalizedCode = item.code?.toLowerCase().trim() || '';
        const normalizedSearch = searchQuery.toLowerCase().trim();
        
         return normalizedCode.includes(normalizedSearch) || 
                normalizedCode.replace('stk', '').includes(normalizedSearch) ||
                normalizedCode.replace('-', '').includes(normalizedSearch);
    });

    return (

        <>
        <div className={`w-[98%] mx-auto flex ${isRTL ? 'justify-end' : 'justify-end'}`}>
        <div className="w-96 mt-4 text-gray-800 relative">
  <div className="relative">
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && suggestions.length > 0) {
          setSearchQuery(suggestions[0]);
        }
      }}
      placeholder={t("requisition.searchbynumberofstocktakings")}
      className="w-full text-sm font-semibold text-gray-700 placeholder-gray-400 bg-white border border-gray-300 rounded-md py-2 px-3 pe-10 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-center shadow-sm"
      dir={isRTL ? 'rtl' : 'ltr'}
      autoComplete="off"
    />
    <div className="absolute top-1/2 transform -translate-y-1/2 right-3">
      <BiSearch className="h-5 w-5 text-gray-400" />
    </div>
  </div>
  {suggestions.length > 0 && (
    <ul className="absolute w-full bg-white border border-gray-300 rounded-md mt-1 max-h-48 overflow-y-auto z-50 shadow-lg">
      {suggestions.map((suggestion, index) => (
        <li
          key={index}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-center"
          onClick={() => {
            setSearchQuery(suggestion);
            setSuggestions([]);
          }}
        >
          {suggestion}
        </li>
      ))}
    </ul>
  )}
</div>
</div>
 
        { stockTakingResult?.data.length===0?
         <NoDataFound msg={t("stocktaking.no_data_available")}/> :  filteredResults.length === 0 ? (
            <NoDataFound msg={t("stocktaking.no_data_available")} />
        ):(<div className="h-screen  max-h-[calc(100vh-265px)] relative">
            {/* Outer container with custom scrollbar */} 
            <div className="sticky top-0 z-10 h-screen max-h-[calc(100vh-230px)]">
            <div className="grid grid-cols-12 gap-3 px-4 mt-2 bg-[#EBF9D9] font-bold text-[#251658] text-sm rounded-t-2xl justify-between items-center border-t py-4 hover:bg-indigo-50 hover:font-bold">
  <div className="text-center col-span-1">#</div>
  <div className="text-center col-span-2">{t('stocktaking.code')}</div>
  <div className=" col-span-3">{t('requisition.warehouse_name_ar')}</div>
  <div className="  col-span-3">{t('requisition.warehouse_name_en')}</div>
  <div className="text-center col-span-1">{t('requisition.creation_date')}</div>
  <div className="text-center col-span-2 mx-2">{t('requisition.status')}</div>
</div>
<div className="custom-scrollbar  h-[calc(100%-4rem)] overflow-y-auto">
            {filteredResults?.map((item, index) => (
                <StockTakingListItem 
                    key={item.id} 
                    index={index} 
                    item={item} 
                    reload={refreshHandler} 
                    isRTL={isRTL}
                />
            ))}
        </div>
        </div>
        </div>)}
        </>
        
    )
}

export default StockTakingList